"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
// import isPortrait from "./utils/isPortrait";
var VideoSources_1 = __importDefault(require("./components/VideoSources"));
var Scene_1 = __importDefault(require("./components/Scene"));
var VideoControls_1 = __importDefault(require("./components/VideoControls"));
var VideoPlayerIds_1 = __importDefault(require("./VideoPlayerIds"));
var Video_1 = __importDefault(require("./styles/Video"));
var VideoContainer_1 = __importDefault(require("./styles/VideoContainer"));
var usePlayerTools_1 = __importDefault(require("./hooks/usePlayerTools"));
var useHls_1 = __importDefault(require("./hooks/useHls"));
var secondVideoPreload_1 = __importDefault(require("./utils/secondVideoPreload"));
var RenderIf_1 = __importDefault(require("./components/RenderIf"));
var VideoPreviewPlayer = function (_a) {
    var _b, _c;
    var videoSources = _a.videoSources, controller = _a.controller, style = _a.style, className = _a.className, campaignMeta = _a.campaignMeta;
    var videoRef = react_1.useRef(null);
    var _d = react_1.useState(false), isPlaying = _d[0], setIsPlaying = _d[1];
    var _e = react_1.useState(0), progress = _e[0], setProgress = _e[1];
    var _f = react_1.useState(""), timerValue = _f[0], setTimerValue = _f[1];
    var _g = react_1.useState(false), isInFullscreen = _g[0], setIsInFullscreen = _g[1];
    var _h = react_1.useState(false), canPlayVideo = _h[0], setCanPlayVideo = _h[1];
    var _j = react_1.useState(videoSources[0]), sources = _j[0], setSources = _j[1];
    var _k = react_1.useState(false), playingSecondVideo = _k[0], setPlayingSecondVideo = _k[1];
    var changeToSecondVideo = function () {
        setSources(videoSources === null || videoSources === void 0 ? void 0 : videoSources[1]);
        setPlayingSecondVideo(true);
    };
    var changeToFirstVideo = function () {
        setSources(videoSources[0]);
        setPlayingSecondVideo(false);
    };
    useHls_1.default({ sources: sources, videoRef: videoRef });
    var _l = usePlayerTools_1.default({
        videoRef: videoRef,
        setCanPlayVideo: setCanPlayVideo,
        playingSecondVideo: playingSecondVideo,
        hasCustomIntro: videoSources.length === 2,
        changeToSecondVideo: changeToSecondVideo,
        changeToFirstVideo: changeToFirstVideo,
        controller: controller,
        campaignMeta: campaignMeta,
    }), onCanPlayHandler = _l.onCanPlayHandler, handleVideoOnVolumeChange = _l.handleVideoOnVolumeChange, volumeLevel = _l.volumeLevel, playNextVideo = _l.playNextVideo, inTransition = _l.inTransition, setInTransition = _l.setInTransition, handleFoward = _l.handleFoward, handleRewind = _l.handleRewind, handlePlayVideoClick = _l.handlePlayVideoClick, getProgress = _l.getProgress;
    // Get initial time.
    react_1.useEffect(function () {
        if (!controller)
            return;
        if (!(controller === null || controller === void 0 ? void 0 : controller.video.currentTime)) {
            controller.getTimerValue();
        }
    }, [controller]);
    react_1.useEffect(function () {
        document.onfullscreenchange = function () {
            return setIsInFullscreen(!!document.fullscreenElement);
        };
        if (!(sources === null || sources === void 0 ? void 0 : sources[0].src))
            setCanPlayVideo(true);
        return function () {
            document.onfullscreenchange = null;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var invertIsPlaying = function () { return setIsPlaying(function (prevState) { return !prevState; }); };
    var handleTimeUpdate = function () {
        setProgress(getProgress());
        setTimerValue(controller === null || controller === void 0 ? void 0 : controller.getTimerValue());
    };
    return (jsx_runtime_1.jsxs(VideoContainer_1.default, __assign({ isPreview: true, id: VideoPlayerIds_1.default.VideoContainer, onMouseUp: controller === null || controller === void 0 ? void 0 : controller.handleProgressBarMouseUp, style: style, className: className }, { children: [jsx_runtime_1.jsx(Video_1.default, __assign({ isPreview: true, id: VideoPlayerIds_1.default.VideoPlayer, ref: videoRef, onClick: handlePlayVideoClick, onPlay: invertIsPlaying, onPause: invertIsPlaying, onTimeUpdate: handleTimeUpdate, onVolumeChange: handleVideoOnVolumeChange, onCanPlay: onCanPlayHandler, onLoadedData: function () { return setCanPlayVideo(true); }, onLoadedMetadata: function () { return setCanPlayVideo(true); }, onEnded: playNextVideo, preload: "auto", isInFullscreen: isInFullscreen, playsInline: true, autoPlay: true, loop: false }, { children: jsx_runtime_1.jsx(VideoSources_1.default, { sources: sources }, void 0) }), void 0), jsx_runtime_1.jsx(RenderIf_1.default, __assign({ condition: !!(videoSources === null || videoSources === void 0 ? void 0 : videoSources[1]) }, { children: jsx_runtime_1.jsx(secondVideoPreload_1.default, { sources: videoSources === null || videoSources === void 0 ? void 0 : videoSources[1] }, void 0) }), void 0), jsx_runtime_1.jsx(Scene_1.default, { handlePlayVideoClick: handlePlayVideoClick, playingSecondVideo: playingSecondVideo, 
                // ALways use sendspark color
                playButtonColor: "#6140FF", controller: controller, canPlayVideo: canPlayVideo, isEditPage: true, videoRef: videoRef, inTransition: inTransition }, void 0), jsx_runtime_1.jsx(VideoControls_1.default, { handlePlayVideoClick: handlePlayVideoClick, handleFoward: handleFoward, handleRewind: handleRewind, isPreview: true, changeToFirstVideo: changeToFirstVideo, changeToSecondVideo: changeToSecondVideo, playingSecondVideo: playingSecondVideo, setInTransition: setInTransition, controller: controller, showControls: !!((_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.played.length) && !((_c = videoRef.current) === null || _c === void 0 ? void 0 : _c.ended), isPlaying: isPlaying, isInFullscreen: isInFullscreen, progress: progress, timerValue: timerValue, volumeLevel: volumeLevel, sendsparkBrandingEnabled: true, hasTwoVideos: !!(videoSources === null || videoSources === void 0 ? void 0 : videoSources[1]), progressBarColor: "#6140FF", campaignMeta: campaignMeta, gapCombinedVideoPlayer: true }, void 0)] }), void 0));
};
exports.default = VideoPreviewPlayer;
